module.exports = __webpack_public_path__ + "img/employee.c39e9944.svg";